// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusLegend__Popup {
  position: absolute;
  top: 0rem;
  left: 4rem;
  z-index: 100;
  min-width: 10rem;
  background: #666;
  color: white;
  padding: 0.5rem;
  border-radius: 0.3rem;
  box-shadow: rgba(0, 0, 0, 0.25) 10px 5px 6px 1px;
}`, "",{"version":3,"sources":["webpack://./libs/features/feat-comparables/src/lib/comparables/comparables-status-legend/statusLegend.component.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,gDAAA;AAAJ","sourcesContent":[".StatusLegend {\n  &__Popup {\n    position: absolute;\n    top: 0rem;\n    left: 4rem;\n    z-index: 100;\n    min-width: 10rem;\n    background: #666;\n    color: white;\n    padding: 0.5rem;\n    border-radius: 0.3rem;\n    box-shadow: rgba(0, 0, 0, 0.25) 10px 5px 6px 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
